module.exports = __webpack_public_path__ + "static/img/tab2.7827fc56.png";